var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"my-px"},[_c('a',{staticClass:"w-full flex flex-row flex-grow items-center h-8 rounded-lg relative hover:bg-white/10 transition-colors",class:[
      _vm.collapse ? 'px-2 text-white/90 dark:text-white/90' : 'px-3 text-white/70 dark:text-white/70',
    ],on:{"click":_vm.toggle}},[_c('div',{staticClass:"w-full flex items-center"},[_c('span',{staticClass:"flex items-center justify-center text-lg",class:[
          _vm.collapse ? '-ml-px' : '',
        ]},[_c('o-icon',{attrs:{"icon":"message","size":18}})],1),_vm._v(" "),_c('span',{staticClass:"ml-4 text-base",class:[ _vm.collapse? 'sm:hidden' : '']},[_vm._v("Support")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }